import React, { FC } from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableSortLabel,
} from "@material-ui/core";
import { useTeamQContext } from "../../../../../context/teamQContextProvider";
import { hideCheckboxes } from "../../../../helpers/hideCheckboxes";
import { useUserContext } from "../../../../../context/userContextProvider";
import { Role } from "../../../../../models";

export type Header = {
  label: string; 
  width?: string;
  sortKey?: string;
}

type Props = {
  headers: Header[] 
  sortHeader: (headerToSort: string)=> void;
  toggleAll: ()=> void;
  rowsLength: number;
  selectedLength: number;
}

const DataTableHeader: FC<Props> = ({ headers, sortHeader, toggleAll, rowsLength, selectedLength }) => {

  const { 
    state: {
      displaySettings: {
        sort
      }
    }
  } = useTeamQContext();
  
  const {state:{user}} = useUserContext();

  const createSortHandler = (property: string) => (): void => {
    sortHeader(property.toString());
  };

  return (
    <TableHead>
      <TableRow>
        {(!hideCheckboxes() || user?.roles.includes(Role.Manager)) && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={selectedLength > 0 && selectedLength < rowsLength}
              checked={rowsLength > 0 && selectedLength === rowsLength}
              onChange={toggleAll}
              inputProps={{ "aria-label": "select all" }}
            />
          </TableCell>
        )}

        {headers.map((header: Header, index: number) => {
            return (  
              <TableCell key={index} style={{ width: header.width || "auto" }}>
                {header.sortKey ? (
                  <TableSortLabel 
                    active={sort?.headerToSort === header.sortKey}
                    direction={sort?.headerToSort === header.sortKey ? sort?.direction : "asc"}
                    onClick={createSortHandler(header.sortKey)}
                  >
                    {header.label}
                  </TableSortLabel>
                ) : 
                (header.label)}
              </TableCell>
            );
        })}
      </TableRow>
    </TableHead>
  );
};

export default DataTableHeader;
